/******************** https://vprotalapi.azurewebsites.net/ connection **********************/
//export const mainurl = 'https://vprotalapi.azurewebsites.net/api/v1/';
//export const fileurl = "https://vprotalapi.azurewebsites.net/uploads/";

/******************** Local connection **********************/
export const mainurl = 'https://shivaent.purpuligo.com/api/v1/';
export const fileurl = "https://shivaent.purpuligo.com/api/v1/";